<template>
  <div class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content" style="background: white">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
              aria-hidden="true">&times;</span></button>
          <h4 class="modal-title">
            <slot name="title"></slot>
          </h4>
        </div>
        <div class="modal-vue modal-body" style="text-align: left">
          <slot name="content"></slot>
        </div>
        <div class="modal-footer" v-if="hasFooterSlot">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  components: {},
  setup() {
    return {}
  },
  methods: {
    hasFooterSlot() {
      return !!this.$slots.footer
    }
  }
}
</script>

<style scoped>
</style>
<style>
.modal-vue .modal-body {
  text-align: left;
}
</style>
